import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

import Module from 'ui/components/Module'

import Hero from 'ui/components/modules/Hero'

import Header from 'ui/components/modules/Header'
import BodyText from 'ui/components/modules/BodyText'
import Quotes from 'ui/components/modules/Quotes'
import ImageAndText from 'ui/components/modules/ImageAndText'
import Distance from 'ui/components/modules/Distance'
import Grades from 'ui/components/modules/Grades'
import Electives from 'ui/components/modules/Electives'
import PageHeader from 'ui/components/modules/PageHeader'
import Wysiwyg from 'ui/components/modules/Wysiwyg'
import Image from 'ui/components/modules/Image'
import Accordions from 'ui/components/modules/Accordions'
import LinkBoxes from 'ui/components/modules/LinkBoxes'
import Videos from 'ui/components/modules/Videos'
import Employees from 'ui/components/modules/Employees';
import Grid from 'ui/components/modules/Grid'
import DaySlider from 'ui/components/modules/DaySlider'

const Wrapper = styled.div`
  background-color: ${props => props.theme.colors.grey.lighter};
  padding-bottom: 120px;

  ${media.xs`
    padding-bottom: 60px;
  `}
`;

const Missing = styled.div`
  padding: 30px;
  background-color: ${props => props.theme.colors.oxford.dark};
  color: white;
  font-size: 18px;
`

export default class Modules extends Component {

  getModules() {
    const {
      modules,
      post,
      type,
      ancestors
    } = this.props
    
    return modules.map((module, index) => {
      const key = index + '-' + module.layout;
      
      switch (module.layout) {
        case 'hero':
          return <Hero {...module} />
        case 'header':
          return <Header {...module} post={post} type={type} />
        case 'bodyText':
          return <BodyText {...module} />
        case 'quotes':
          return <Quotes {...module} />
        case 'imageAndText':
          return <ImageAndText {...module} />
        case 'distance':
          return <Distance {...module} />
        case 'grades':
          return <Grades {...module} />
        case 'electives':
          return <Electives {...module} />
        case 'pageHeader':
          return <PageHeader {...module} ancestors={ancestors} pageTitle={post.title} />
        case 'wysiwyg':
          return <Wysiwyg {...module} />
        case 'image':
          return <Image {...module} />
        case 'accordions':
          return <Accordions {...module} />
        case 'linkBoxes':
          return <LinkBoxes {...module} />
        case 'videos':
          return <Videos {...module} />
        case 'employees':
          return <Employees {...module} />
        case 'grid':
          return <Grid {...module} />
        case 'daySlider':
          return <DaySlider {...module} />
        default:
          return <Missing key={key}>Missing implementation of {module.layout}</Missing>
      }
    });
  }

  render() {
    return (
      <Wrapper>
        {this.getModules().map((module, index) => <Module key={index}>{module}</Module>)}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/Modules.js